import { commonShortNouns } from "./common-short-fields";

export const examAdminCustomFieldDefinitions = {
  pageTitle: "Custom Fields",
  pageSubtitle:
    "Manage custom field definitions and business attributes for candidates, exams, and images.",
  archiveAction: "Archive",
  createSuccess: "Field created",
  updateSuccess: "Field updated",
  archiveSuccess: "Field archived",
  confirmArchiveTitle: "Archive this field?",
  targets: {
    candidate: "Candidate",
    exam: "Exam",
    docker_image: "Image",
  },
  objects: {
    field: "field",
  },
  table: {
    target: "Target",
    fieldKey: "Key",
    fieldLabel: "Label",
    dataType: "Type",
    visibility: "Visibility",
    editability: "Editable",
    requiredOnLogin: "Required on Login",
    status: commonShortNouns.status,
    actions: "Actions",
  },
  form: {
    target: "Target",
    fieldKey: "Field Key",
    fieldLabel: "Field Label",
    dataType: "Field Type",
    requiredOnLogin: "Required on login (candidate only)",
    visibility: "Visibility",
    editability: "Editability",
    optionsText: "Options (one per line, used by select/multi_select)",
    placeholder: "Placeholder",
    helpText: "Help text",
    sortOrder: "Sort order",
    status: commonShortNouns.status,
    placeholders: {
      fieldKey: "e.g. employee_no / emergency_contact",
      fieldLabel: "e.g. Employee No. / Emergency Contact",
      optionsText: "e.g.\nJunior\nMid\nSenior",
      placeholder: "e.g. Please enter employee number",
      helpText: "e.g. Used for profile completion after login",
      sortOrder: "e.g. 10 (smaller number shows first)",
    },
  },
  labels: {
    active: "Active",
    archived: "Archived",
    visible: "Visible",
    hidden: "Hidden",
    editable: "Editable",
    readonly: "Read-only",
  },
};
